<template>
  <div class="grid-x" :class="!noMarginTop && 'margin-top-xxs'">
    <div class="cell small-12 medium-7">
      <Form v-slot="{ meta }" @submit="submitForm">
        <div class="cell">
          <InputText
            :id="rmaId || 'email-input'"
            ref="emailInput"
            v-model="email"
            name="email"
            label="Email"
            rule="email"
            @input="onInput"
            @blur="onBlur"
            @on-clear="onClear"
          />
        </div>
        <div
          v-if="returnConfirmationStore.returnLabel.error && returnConfirmationStore.returnLabel.rmaId === rmaId"
          id="js-service-error"
          class="error_msg"
        >
          The email could not be sent. Please try again
        </div>
        <div class="cell">
          <AppButton
            class="button send"
            :class="[isMcom ? 'primary' : 'secondary', noMarginTop ? 'margin-top-xxs' : 'margin-top-xs']"
            :disabled="meta.valid ? false : true"
            :loading="loading"
          >
            Send
          </AppButton>
        </div>
      </Form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Form from '@atomic-ui/form';
import InputText from '@atomic-ui/inputText/InputText';
import AppButton from '@/components/AppButton';

// Composables
import { useReturnConfirmationStore } from '@/stores/returns/useReturnConfirmationStore';
import useBrand from '@/composables/useBrand';
const props = defineProps({
  noMarginTop: {
    type: Boolean,
    required: false,
    default: false,
  },
  rmaId: {
    type: String,
    default: '',
  },
  loading: {
    type: Boolean,
    required: false,
  },
});

const email = ref('');
const emailInput = ref(null);

const { isMcom } = useBrand();
const returnConfirmationStore = useReturnConfirmationStore();
const sendReturnLabelEmail = async () => {
  await returnConfirmationStore.SEND_RETURN_LABEL_EMAIL({
    emailAddress: email.value,
    rmaId: props.rmaId,
  });
};

const setReturnLabelError = (payload) => {
  returnConfirmationStore.SET_RETURNLABEL_ERROR(payload);
};

const submitForm = async (_, { resetForm }) => {
  if (returnConfirmationStore.returnLabel.error) {
    setReturnLabelError({ error: false });
  }
  await sendReturnLabelEmail();
  resetForm();
  returnConfirmationStore.SET_ID('');
};

const onInput = () => {
  if (returnConfirmationStore.returnLabel.error) {
    setReturnLabelError({ error: false });
  }
};

const onBlur = () => {
  if (returnConfirmationStore.returnLabel.error || email.value === '') {
    setReturnLabelError({ error: false });
  }
};

onMounted(() => {
  emailInput.value?.$el?.nextSibling?.children?.[props.rmaId || 'email-input']?.focus();
});

const onClear = () => {
  emailInput.value?.$el?.nextSibling?.children?.[props.rmaId || 'email-input']?.focus();
};
</script>

<style lang="scss" scoped>
.send {
  width: 100%;
}
.error_msg {
  color: $error-color;
}
</style>
